var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"road",style:({width: ((_vm.squareNum * 3.5) + "px")})},_vm._l((_vm.squareNum),function(square){return _c('div',{key:square,staticClass:"square",class:{bottom: Math.random() > .5},style:({
      height: ((_vm.squareHeight * 2) + "px"),
      width: ((3.5) + "px")
    })},[_c('div',{staticClass:"square-content",style:({height: (_vm.squareHeight + "px")})})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }